import { Lock } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import type { NavGroup, NavRow as NavRowType } from './navModel'

export const ROW_CLASS =
  'flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-sm text-neutral-700 hover:bg-ink-50'
export const ICON_CLASS = 'size-4 shrink-0 text-neutral-400'
export const GROUP_LABEL_CLASS = 'px-2 pb-1 text-xs font-medium text-neutral-500'

export function NavRow({ row }: { row: NavRowType }) {
  const Icon = row.icon

  if (row.featured) {
    return (
      <div className="border-brand-200 bg-brand-50 my-1 rounded-lg border">
        <div className={cn(ROW_CLASS, 'py-3 hover:bg-transparent')}>
          <Icon className={cn(ICON_CLASS, 'text-neutral-900')} />
          <span className="truncate font-medium">{row.label}</span>
          {row.tag && (
            <Badge className="ml-auto px-1.5 py-0 text-[10px] leading-4 tracking-wider">{row.tag}</Badge>
          )}
        </div>
      </div>
    )
  }

  return (
    <div
      className={cn(
        ROW_CLASS,
        row.active && 'font-semibold text-neutral-900',
        row.locked && 'cursor-default text-neutral-400 hover:bg-transparent'
      )}
    >
      <Icon className={cn(ICON_CLASS, row.active && 'text-neutral-900', row.locked && 'text-neutral-300')} />
      <span className="truncate">{row.label}</span>
      {row.locked && <Lock className="ml-auto size-3 shrink-0 text-neutral-300" />}
      {!row.locked && row.tag && (
        <span className="ml-auto text-[10px] font-medium tracking-wider text-neutral-400 uppercase">
          {row.tag}
        </span>
      )}
    </div>
  )
}

export function NavGroupBlock({ group, locked }: { group: NavGroup; locked?: boolean }) {
  return (
    <div className="border-ink-50 border-t px-2 py-3 first:border-t-0">
      {group.label && (
        <div className={cn(GROUP_LABEL_CLASS, locked && 'text-neutral-400')}>
          {locked ? `${group.label} — not enabled` : group.label}
        </div>
      )}
      <div className="flex flex-col gap-0.5">
        {group.rows.map((row) => (
          <NavRow key={row.label} row={{ ...row, locked: locked || row.locked }} />
        ))}
      </div>
    </div>
  )
}
